import request from '../../utils/requests'
/** * Tag: QuicklyComment */
const baseUrl ="/api/QuicklyComment";

/** * 快评包分页 * @param {*} body * { *    QuicklyCommentContent Desc:快捷评论包名称 Required:false *    BranchId Desc:校区ID(机构时传[]，校区时传当前登录校区ID) Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _paging(body) {  return request(baseUrl+'/paging',{    method: 'POST',    body: body,  });
}

/** * 获取快评包信息(父级和子集) * @param {*} param * { *    quicklyCommentId Desc:快评ID Required:true * } */async function _getPackageInfo(param) {  return request(baseUrl+'/getPackageInfo',{    method: 'GET',    params: param,  });
}

/** * 新增快评包 * @param {*} body * { *    QuicklyCommentId Desc:ID,新增时0 Required:false *    Name Desc:快捷评论包名 Required:false *    QuicklyCommentContent Desc:快捷评论包内容 Required:false *    BranchId Desc:校区ID(机构新增时填0，校区新增时填当前校区ID) Required:false * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

/** * 更新快评包 * @param {*} body * { *    QuicklyCommentId Desc:ID,新增时0 Required:false *    Name Desc:快捷评论包名 Required:false *    QuicklyCommentContent Desc:快捷评论包内容 Required:false *    BranchId Desc:校区ID(机构新增时填0，校区新增时填当前校区ID) Required:false * } */async function _update(body) {  return request(baseUrl+'/update',{    method: 'POST',    body: body,  });
}

/** * 删除快评包 * @param {*} param * { *    quicklyCommentId Desc:ID Required:true * } */async function _delete(param) {  return request(baseUrl+'/delete',{    method: 'GET',    params: param,  });
}

export default{  _paging,  _getPackageInfo,  _add,  _update,  _delete}



// WEBPACK FOOTER //
// ./src/services/quicklyComment.js